/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .happ-heading[_ngcontent-%COMP%]{padding:12px;font-size:20px;background:#f0f8ff}[_nghost-%COMP%]   .happ-heading[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{text-align:center}[_nghost-%COMP%]   .happ-content[_ngcontent-%COMP%]{padding:8px;background:#fff;cursor:pointer;border-bottom:1px solid #e0e0e0}[_nghost-%COMP%]   .happ-content[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{text-align:center;font-size:18px}[_nghost-%COMP%]   .happ-content[_ngcontent-%COMP%]:hover{background:#f7f6f6}"];
export { styles as styles };
